import * as React from 'react';
import { useTranslation } from 'react-i18next';

// ─── Component ────────────────────────────────────────────────────────────────

export function PageError(): React.JSX.Element {
  const { t } = useTranslation('settings');
  return (
    <div className="flex h-64 flex-col items-center justify-center gap-2">
      <p className="text-lg font-semibold">{t('orderTypes.error.title')}</p>
    </div>
  );
}

export function AccessDenied(): React.JSX.Element {
  const { t } = useTranslation('settings');
  return (
    <div className="flex h-64 flex-col items-center justify-center gap-2">
      <p className="text-lg font-semibold">{t('common.accessDeniedTitle')}</p>
      <p className="text-muted-foreground">{t('orderTypes.accessDenied.description')}</p>
    </div>
  );
}
